function GameContainer($screen, desiredWidth, desiredHeight)
{
	this.$screen = $screen;
	this.$window = $(window);
	this.desiredWidth = desiredWidth;
	this.desiredHeight = desiredHeight;
	this.desiredRatio = desiredWidth / desiredHeight;
	this.width = 0;
	this.height = 0;
	this.onPortrait = null;
	this.onLandscape = null;
}

GameContainer.prototype = {
	
	/**
	 * Styles to apply to the screen.
	 */
	screenStyle: 
	{
		position: 'relative'
	},
	
	/**
	 * Registers listeners.
	 */
	register: function()
	{
		var $this = this;
		
		$this.$window.resize(function() {
			$this.resize();
		});
		
		$this.$screen.data('container', $this);
	},
	
	/**
	 * Styles the screen
	 */
	style: function()
	{
		this.$screen.css( this.screenStyle );
	},
	
	/**
	 * Returns the current vertical scroll value.
	 */
	scrollTop: function() 
	{
		return window.pageYOffset || 
		 			 window.document.compatMode === "CSS1Compat" && window.document.documentElement.scrollTop || 
				   window.document.body.scrollTop || 
				   0;
	},
	
	/**
	 * Try to hide the address bar
	 */
	hideBar: function() 
	{
		window.scrollTo( 0, this.scrollTop() === 1 ? 0 : 1 );
	},
	
	/**
	 * Takes an educated guess on whether the browsing device is mobile. This is accurrate enough for it's use.
	 */
	isMobile: function()
	{
		if (typeof this.mobile === 'undefined')
		{
			this.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		}
		return this.mobile;
	},
	
	/**
	 * Does this look like landscape?
	 */
	isLandscape: function()
	{
		return this.$window.width() >= this.$window.height();
	},
	
	/**
	 * Returns the scale of the screen (it shrinks if the viewport isn't big enough).
	 */
	getScale: function()
	{
		return this.width / this.desiredWidth;
	},
	
	/**
	 * Handles calculating the width & height of the screen, centering it, and
	 * determining whether its portrait or landscape (and throws the appropriate event).
	 */
	resize: function()
	{
		var $windowWidth = this.$window.width();
		var $windowHeight = this.$window.height();
		
		// compute ratios to determine which dimension needs to be scaled wrt the other.
		var $windowRatio = $windowWidth / $windowHeight;
		
		this.width = this.desiredWidth;
		this.height = this.desiredHeight;
		
		if ($windowRatio > this.desiredRatio)
		{
			if (this.height > $windowHeight)
			{
				this.width = Math.floor( this.width * $windowHeight / this.height );
				this.height = $windowHeight;
			}
		}
		else
		{
			if (this.width > $windowWidth)
			{
				this.height = Math.floor( this.height * $windowWidth / this.width );
				this.width = $windowWidth;
			}
		}
		
		// center screen
		this.$screen.css(
		{
			'width': 	this.width,
			'height': this.height,
			'top': 		($windowHeight - this.height) / 2,
			'left': 	($windowWidth - this.width) / 2
		});
		
		// tries to hide the address bar
		this.hideBar();
		
		// non-mobile devices are always landscape... you can't really re-orient them.
		var eventType = !this.isLandscape() && this.isMobile() ? 'portrait' : 'landscape';
		
		var event = jQuery.Event( eventType );
		event.container = this;
		event.width = this.width;
		event.height = this.height;
		event.scale = this.getScale();
		
		this.$screen.trigger( event );
	}
	
};